import React, { Fragment } from 'react';
import './Plus.scss';
import {DateInput, SelectInput, TextInput, CheckboxInput} from '../_common';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import {getNestedPropertyValue, setNestedPropertyValue} from "../../helpers/helpers";
import _ from "lodash";

const Plus = (
  {
    label,
    name,
    itemObject,
    itemInputs,
    value,
    onChange,
    disabled,
    displayedItemsFilter,
    displayedItemsFilterValue,
    nestedPlusName,
    nestedPlusObject,
    nestedPlusItemInputs,
    mini
  }
) => {

  const addItem = () => {
    const newItems = [...value];
    newItems.push(itemObject);
    onChange(name, newItems);
  };

  const removeItem = index => {
    const newItems = [...value];
    newItems.splice(index, 1);
    onChange(name, newItems, false, true);
  };

  const changeValue = (itemName, itemValue, index, multiple, blur, type) => {
    const newValues = [...value];
    if (!!itemName) {
      if (multiple) {
        if (!getNestedPropertyValue(newValues[index], itemName).includes(itemValue.id ? itemValue.id : itemValue)) {
          const newValue = [...getNestedPropertyValue(newValues[index], itemName), itemValue.id ? itemValue.id : itemValue];
          const updatedValues = setNestedPropertyValue(newValues[index], itemName, newValue);
          newValues[index] = updatedValues;
        } else {
          const newValue = [...getNestedPropertyValue(newValues[index], itemName)];
          const i = newValue.indexOf(itemValue.id ? itemValue.id : itemValue);
          newValue.splice(i, 1);
          const updatedValues = setNestedPropertyValue(newValues[index], itemName, newValue);
          newValues[index] = updatedValues;
        }
      } else {
        if (itemName.includes(".")) {
          const updatedValues = setNestedPropertyValue(newValues[index], itemName, itemValue);
          newValues[index] = updatedValues;
        } else {
          newValues[index][itemName] = itemValue;
        }
      }
    } else {
      newValues[index] = itemValue;
    }
    onChange(name, newValues, false, blur, type);
  };

  const changeNestedPlusValue = (itemName, itemValue, parentIndex, blur) => {
    const newValues = [...value];
    newValues[parentIndex][itemName] = itemValue;
    onChange(name, newValues, false, blur);
  };

  const valuesToDisplay = displayedItemsFilter
    ? value.map((item, i) => ({...item, index: i})).filter(item => item[displayedItemsFilter] === displayedItemsFilterValue)
    : value;

  return (
    <div className='Plus'>
      <div className='plusLabel'>
        {label}
      </div>
      <div className='plusContent'>
        {valuesToDisplay.map((item, index) => (
          <div className='plusItem' key={index}>
            {!disabled && (
              <div
                className='plusRemoveButton'
                onClick={() => removeItem(!displayedItemsFilter ? index : item.index)}
              >
                <ClearIcon />
              </div>
            )}
            <div className='plusItemInputs'>
              {itemInputs.map((input, i) => (
                <Fragment key={i}>
                  {input.type === 'text' && (!input.visible || getNestedPropertyValue(item, input.visible))  && (
                    <TextInput
                      label={input.label}
                      required={input.required}
                      name={input.name}
                      onChange={(itemName, itemValue) =>
                        changeValue(itemName, itemValue, !displayedItemsFilter ? index : item.index)}
                      onBlur={(itemName, itemValue) =>
                        changeValue(
                          itemName, itemValue, !displayedItemsFilter ? index : item.index, false , true, 'text'
                        )}
                      value={input.name ? getNestedPropertyValue(item, input.name) : item}
                      disabled={disabled || input.disabled}
                      link={input.link}
                      mini={mini}
                    />
                  )}
                  {input.type === 'textarea' && (!input.visible || getNestedPropertyValue(item, input.visible))  && (
                    <TextInput
                      label={input.label}
                      required={input.required}
                      name={input.name}
                      onChange={(itemName, itemValue) =>
                        changeValue(itemName, itemValue, !displayedItemsFilter ? index : item.index)}
                      onBlur={(itemName, itemValue) =>
                        changeValue(
                          itemName, itemValue, !displayedItemsFilter ? index : item.index, false , true, 'text'
                        )}
                      value={input.name ? getNestedPropertyValue(item, input.name) : item}
                      disabled={disabled || input.disabled}
                      area
                      mini={mini}
                    />
                  )}
                  {input.type === 'date' && (!input.visible || getNestedPropertyValue(item, input.visible)) && (
                    <DateInput
                      label={input.label}
                      required={input.required}
                      name={input.name}
                      onChange={(itemName, itemValue) =>
                        changeValue(
                          itemName,
                          itemValue,
                          !displayedItemsFilter ? index : item.index,
                          false,
                          true,
                          'date'
                        )
                      }
                      value={input.name ? getNestedPropertyValue(item, input.name) : item}
                      disabled={disabled || input.disabled}
                      mini={mini}
                    />
                  )}
                  {input.type === 'checkbox' && (!input.visible || getNestedPropertyValue(item, input.visible)) && (
                    <CheckboxInput
                      label={input.label}
                      required={input.required}
                      name={input.name}
                      onChange={(itemName, itemValue) =>
                        changeValue(
                          itemName,
                          itemValue,
                          !displayedItemsFilter ? index : item.index,
                          false ,
                          true,
                          'checkbox'
                        )
                      }
                      value={input.name ? getNestedPropertyValue(item, input.name) : item}
                      disabled={disabled || input.disabled}
                      index={!displayedItemsFilter ? index : item.index}
                      mini={mini}
                    />
                  )}
                  {input.type === 'select' && (!input.visible || getNestedPropertyValue(item, input.visible)) && (
                    <SelectInput
                      label={input.label}
                      required={input.required}
                      name={input.name}
                      options={input.options}
                      onSelect={(itemName, itemValue) =>
                        changeValue(
                          itemName,
                          itemValue,
                          !displayedItemsFilter ? index : item.index,
                          input.multiple,
                          true,
                          'select'
                        )
                      }
                      value={input.name ? getNestedPropertyValue(item, input.name) : item}
                      placeholder={input.placeholder}
                      disabled={disabled || input.disabled}
                      multiple={input.multiple}
                      mini={mini}
                    />
                  )}
                  {input.type === 'separator' && (
                    <div className='separator' />
                  )}
                </Fragment>
              ))}
              {!!nestedPlusName && (
                <Plus
                  name={nestedPlusName}
                  value={valuesToDisplay[index][nestedPlusName]}
                  itemObject={nestedPlusObject}
                  onChange={(name, val, multi, save) => changeNestedPlusValue(name, val, index, save)}
                  disabled={disabled}
                  itemInputs={nestedPlusItemInputs}
                  mini={mini}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      {!disabled && (
        <div className='plusAddButton' onClick={addItem}>
          <AddIcon />
        </div>
      )}
    </div>
  );
}

export default Plus;
